import Panel from './Panel.js';
import { gsap } from 'gsap';

/**
 * Panel Class.
 */
export default class PanelFilters extends Panel {
  isOpen = false;

  static config = {
    name: 'PanelFilters',
    refs: ['items[]', ...Panel.config.refs],
  };

  /**
   * Show Popin
   * @returns {void}
   */
  openPanel() {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.header.classList.remove('z-40');
    this.header.classList.add('z-10');
    this.$el.classList.remove('hidden');

    setTimeout(() => {
      this.$el.classList.remove('pointer-events-none');
      this.$refs.overlay.classList.remove('opacity-0');
      this.$refs.panel.classList.remove('translate-x-full', 'pointer-events-none');

      gsap.fromTo(
        this.$refs.items,
        {
          opacity: 0,
          y: -30,
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          delay: 0.2,
          stagger: 0.08,
          ease: 'power4.out',
        },
      );
    }, 200);
  }
}
